import { extendTailwindMerge } from 'tailwind-merge';
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            duration: [{ duration: ['instant', 'fast', 'base', 'slow', 'slower'] }],
            ease: [{ ease: ['enter', 'exit'] }],
        },
    },
});
export function classNames(...classes) {
    return twMerge(...classes.filter(Boolean));
}
